import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Doctor type definition
export interface Doctor {
  id: string
  full_name: string
  specialization: string
  hospital_id: string
  is_active: boolean
}

// Function to fetch doctors for dropdown
export const fetchDoctorsForDropdown = async (hospitalId: string): Promise<Pick<Doctor, 'id' | 'full_name'>[]> => {
  try {
    const { data, error } = await supabase
      .from('doctors')
      .select('id, full_name')
      .eq('hospital_id', hospitalId)
      .eq('is_active', true)
      .order('full_name')

    if (error) {
      console.error('Error fetching doctors:', error)
      throw error
    }

    return data || []
  } catch (error) {
    console.error('Error in fetchDoctorsForDropdown:', error)
    return []
  }
}